import Link from 'next/link';
import { TrendingUp } from 'lucide-react';

export function Footer() {
	return (
		<footer className="bg-gray-900 text-white py-16 px-6 lg:px-8">
			<div className="mx-auto max-w-6xl">
				<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
					{/* Logo and Description */}
					<div className="col-span-1">
						<div className="flex items-center space-x-3 mb-4">
							<div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
								<span className="text-white font-bold text-xl tracking-wider">
									NOS
								</span>
							</div>
							<span className="text-2xl font-semibold">Lead</span>
						</div>
						<p className="text-gray-300 mb-6 max-w-md">
							AI-powered email verification and lead generation platform.
						</p>
					</div>

					{/* Essential Links */}
					<div>
						<h3 className="text-lg font-semibold mb-4">Legal</h3>
						<ul className="space-y-2">
							<li>
								<Link
									href="/privacy"
									className="text-gray-300 hover:text-white transition-colors"
								>
									Privacy Policy
								</Link>
							</li>
							<li>
								<Link
									href="/terms"
									className="text-gray-300 hover:text-white transition-colors"
								>
									Terms of Service
								</Link>
							</li>
						</ul>
					</div>
				</div>

				<div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
					<p className="text-gray-400 text-sm">
						© 2025 NOS Tech, Inc. All rights reserved.
					</p>
					<div className="flex items-center space-x-6 mt-4 md:mt-0">
						<Link
							href="/privacy"
							className="text-gray-400 hover:text-white text-sm transition-colors"
						>
							Privacy Policy
						</Link>
						<Link
							href="/terms"
							className="text-gray-400 hover:text-white text-sm transition-colors"
						>
							Terms of Service
						</Link>
					</div>
				</div>
			</div>
		</footer>
	);
}
